import {TRegisterClientRequest} from "../../domain/repository/apply_client_repository";
import {TCreateCustomerRequest} from "../../domain/repository/customer_repository";

interface ICreateCustomerRequest {
    createCustomerRequest: TCreateCustomerRequest,
    email: string;
    password: string;

}
class CreateCustomerRequest implements ICreateCustomerRequest {
    public createCustomerRequest: TCreateCustomerRequest;
    public email: string;
    public password: string;

}

interface IOnAuthListenerRequest {
}
class OnAuthListenerRequest implements IOnAuthListenerRequest {
}

interface IOffAuthListenerRequest {
}
class OffAuthListenerRequest implements IOffAuthListenerRequest {
}

interface ILoginRequest {
    email: string;
    password: string;
}
class LoginRequest implements ILoginRequest {
    public email: string;
    public password: string;
}

interface IPasswordResetRequest {
    email: string;
}
class PasswordResetRequest implements IPasswordResetRequest {
    public email: string;
}


interface IApplyClientRequest {
    registerClientRequest?: TRegisterClientRequest
}
class ApplyClientRequest implements IApplyClientRequest {
    public registerClientRequest: TRegisterClientRequest
}

export {
    CreateCustomerRequest,
    OnAuthListenerRequest,
    OffAuthListenerRequest,
    LoginRequest,
    PasswordResetRequest,
    ApplyClientRequest,
}



// WEBPACK FOOTER //
// ./src/presentation/request/auth_request.ts